/**
 * Planning Centre sign-in helpers. The backend's start/callback round trip doesn't carry the
 * portal path the member was heading to, so it is kept in sessionStorage for the callback page.
 * The callback URL must be in UserManagement's PlanningCentreLogin:AllowedRedirectUris AND in the
 * Planning Centre OAuth app's redirect URIs.
 */
const REDIRECT_KEY = 'rides.pco.redirect';

export const PLANNING_CENTRE_CALLBACK_PATH = '/auth/oauth/planning-centre/callback';

export function planningCentreCallbackUrl(): string {
  return `${window.location.origin}${PLANNING_CENTRE_CALLBACK_PATH}`;
}

/** Only same-app absolute paths are honoured (no open redirects). */
export function safeRedirect(path: string | null | undefined, fallback = '/home'): string {
  return path && path.startsWith('/') && !path.startsWith('//') ? path : fallback;
}

export function rememberPlanningCentreRedirect(path: string): void {
  try {
    sessionStorage.setItem(REDIRECT_KEY, safeRedirect(path));
  } catch {
    /* private mode — the callback falls back to /home */
  }
}

export function takePlanningCentreRedirect(): string {
  try {
    const v = sessionStorage.getItem(REDIRECT_KEY);
    sessionStorage.removeItem(REDIRECT_KEY);
    return safeRedirect(v);
  } catch {
    return '/home';
  }
}
